import React, { useContext, useRef, useState } from 'react'
import styles from "./products.module.css"
import { store } from '../state/state'
import { translate } from '../state/translate'

export default function ProductsList() {
  const [seeMore, setSeeMore] = useState(false)
  const [seeMoreEvents, setSeeMoreEvents] = useState(false)
  let {selectedLang} = useContext(store)
  const eventsRef = useRef()
  const orderRef = useRef()

  // Bring the product back into view on close, otherwise the page jumps while the long text collapses
  const closeMore = (setter, ref) => {
    setter(false)
    ref.current?.scrollIntoView({behavior: "smooth", block: "start"})
  }

  return (
    <div className={styles['products']} id="products">
        <div className={`${styles['products-container']}`} ref={eventsRef}>
        <div className={styles['product-item']}>
          <div className={styles['main-image-container']}>
            <div className={`${styles['rotated']} ${styles['event-manager-image']}`}></div>
          </div>
          <div className={styles['description']}>
            <div className={styles['products-header']}>
              <h1>Event Manager</h1>
            </div>
            <p>
                {translate[selectedLang].eventManager1}
            </p>
            {!seeMoreEvents && <div className={styles['more']}>
              <p onClick={() => setSeeMoreEvents(true)}>{translate[selectedLang].seeMore}</p>
            </div>}
          </div>
        </div>
        <div className={`${styles['collapsible']} ${seeMoreEvents ? styles['expanded'] : ''}`} inert={!seeMoreEvents}>
        <div className={styles['more-description']}>
          <p>
            {translate[selectedLang].eventManager2}
          </p>
          <img src="eventmanager1.jpg" loading="lazy" alt="planning an event" className={styles['waiting-image']}/>
          <p>
            {translate[selectedLang].eventManager3}
          </p>
          <div className={styles['images-happy']}>
            <img src="eventmanager2.jpg" loading="lazy" alt="Event Manager app" />
            <img src="eventmanager3.jpg" loading="lazy" alt="Event Manager booking calendar" />
          </div>
          <p>
            {translate[selectedLang].eventManager4}
          </p>
          <p className={styles['last-paragraph']}>
            {translate[selectedLang].eventManager5}
          </p>
          <a href="https://events.aks.am" target="_blank" rel="noopener noreferrer" className={styles['site-link']}>
            {translate[selectedLang].visitSite} - events.aks.am
          </a>
          <div className={styles['more']}>
              <p onClick={() => closeMore(setSeeMoreEvents, eventsRef)}>{translate[selectedLang].close}</p>
          </div>
        </div>
        </div>
      </div>
      <div className={`${styles['products-container']} ${styles['next-product']}`} ref={orderRef}>
        <div className={styles['product-item']}>
          <div className={styles['main-image-container']}>
            <div className={styles['rotated']}></div>
          </div>
          <div className={styles['description']}>
            <div className={styles['products-header']}>
              <h1>Easy Order</h1>
            </div>
            <p >
                {translate[selectedLang].product1}
            </p>
            {!seeMore && <div className={styles['more']}>
              <p onClick={() => setSeeMore(true)}>{translate[selectedLang].seeMore}</p>
            </div>}
          </div>
       
        </div>
        <div className={`${styles['collapsible']} ${seeMore ? styles['expanded'] : ''}`} inert={!seeMore}>
        <div className={styles['more-description']}>
          <p>
             {translate[selectedLang].product2}
          </p>
          <img src="waiting.webp" loading="lazy" alt="waiting" className={styles['waiting-image']}/>
          <p>
            {translate[selectedLang].product3}
          </p>
          <p>
            {translate[selectedLang].product4}
          </p>
          <div className={styles['images-happy']}>
            <img src="customer.webp" loading="lazy" alt="customer" />
            <img src="happy.webp" loading="lazy" alt="happy" />
          </div>
          <p>
            {translate[selectedLang].product5}
          </p>
          <p className={styles['last-paragraph']}>
            {translate[selectedLang].product6}
          </p>
          <p >
            {translate[selectedLang].product7}
          </p>
          
          <div className={styles['more']}>
              <p onClick={() => closeMore(setSeeMore, orderRef)}>{translate[selectedLang].close}</p>
          </div>
        </div>
        </div>
      </div>
    
    </div>
  )
}
